module.exports = __webpack_public_path__ + "img/img_hc.68a3ff8e.png";